import React from 'react';
import {Box, Stack} from '@mui/material';
import PropTypes from 'prop-types';

const categoryColours = {
    Admissions: '#0dad95',
    Boarding: '#dc2626',
    Staff: '#eab308',
    General: '#2563eb',
    Blank: '#d0d0d0',
};

const FormBuilderPreviewVisual = ({category}) => {
    const bg = categoryColours[category] || categoryColours.General;

    return (
        <Box
            sx={{
                width: '100%',
                height: '65%',
                backgroundColor: bg,
                p: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    height: '80%',
                    backgroundColor: '#fff',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    boxShadow: '0 3px 8px rgba(0,0,0,0.1)',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: 0.6,
                        p: 1.2,
                        borderBottom: '1px solid #f0f0f0',
                    }}
                >
                    {[...Array(3)].map((_, i) => (
                        <Box
                            key={i}
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '2px',
                                backgroundColor: '#d1d5db',
                            }}
                        />
                    ))}
                </Box>

                <Box sx={{
                    flexGrow: 1,
                    px: 1.5,
                    pt: 1
                }}>
                    <Stack spacing={0.8}>
                        <Box sx={{
                            height: 12,
                            width: '94%',
                            backgroundColor: '#e5e7eb',
                            borderRadius: 1
                        }}/>
                        <Box sx={{
                            height: 12,
                            width: '85%',
                            backgroundColor: '#e5e7eb',
                            borderRadius: 1
                        }}/>
                        <Box sx={{
                            height: 12,
                            width: '92%',
                            backgroundColor: '#e5e7eb',
                            borderRadius: 1
                        }}/>
                    </Stack>

                    <Box sx={{
                        height: 1,
                        width: '100%',
                        backgroundColor: '#eeeeee',
                        my: 1
                    }}/>

                    <Box
                        sx={{
                            height: 20,
                            width: '70%',
                            backgroundColor: '#cbd5e1',
                            borderRadius: 1,
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        height: 28,
                        backgroundColor: '#f3f4f6',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 0.6,
                        borderTop: '1px solid #e5e7eb',
                    }}
                >
                    {[...Array(5)].map((_, i) => (
                        <Box
                            key={i}
                            sx={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: i === 0 ? bg : '#d1d5db',
                            }}
                        />
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

FormBuilderPreviewVisual.propTypes = {
    category: PropTypes.string,
};

export default FormBuilderPreviewVisual;
